import { IFetchResult, IFormStore } from 'src/core/classes/helpers/store/Interfaces'

export const updateItem = <T, R>(
  dataStore: IFormStore<T>,
  keyField: string,
  query: string,
  data: IFetchResult<T>,
  row: T,
  currentForm: T[],
  ind: number,
  curIndex: number,
  hierarchyField?: string,
  closeExpandedRoot?: (root: R | null) => void
) => {
  const addData = () => {
    data.items.splice(curIndex, 1, Object.assign(currentForm[ind] as any, row))
  }
  if (!query) {
    if (hierarchyField) {
      if (isChangedParent<T>(row, hierarchyField, currentForm, ind)) {
        reassignParent<T, R>(
          keyField,
          dataStore,
          row,
          hierarchyField,
          currentForm,
          ind,
          data,
          curIndex,
          closeExpandedRoot
        )
      } else {
        addData()
      }
    } else {
      addData()
    }
  } else {
    addData()
  }
}

const isChangedParent = <T>(row: T, hierarchyField: string, currentForm: T[], ind: number) =>
  row[hierarchyField] !== currentForm[ind][hierarchyField]

const reassignParent = <T, R>(
  keyField: string,
  dataStoreProp: IFormStore<T>,
  row: T,
  hierarchyField: string,
  currentForm: T[],
  ind: number,
  data: IFetchResult<T>,
  curIndex: number,
  closeExpandedRoot?: (root: R | null) => void
) => {
  const dataStore = { ...dataStoreProp }
  let groupFound = false
  for (const key of Object.keys(dataStore.queries)) {
    if (row[hierarchyField] === currentForm[ind][hierarchyField]) {
      // oldItemWas updated
      data.items.splice(curIndex, 1, Object.assign(currentForm[ind] as any, row))
      groupFound = true
      continue
    }
    const currentQuery = dataStore.queries[key]
    if (currentQuery && currentQuery.groups) {
      for (const group of currentQuery.groups) {
        if (!group.length) {
          continue
        }
        if (isGroupFoundForNewItem<T>(group, hierarchyField, row)) {
          removeAllOldItemsFromEachGroup(
            dataStore,
            keyField,
            hierarchyField,
            currentForm,
            ind,
            closeExpandedRoot
          )
          group.push(Object.assign(currentForm[ind] as any, row))
          groupFound = true
        } else if (isGroupFoundForOldItem(group, hierarchyField, currentForm, ind)) {
          removeItemFromGroup(keyField, group, currentForm, ind, hierarchyField, closeExpandedRoot)
        }
      }
    }
  }
  if (!groupFound) {
    assignNewItemToEachGroup(dataStore, currentForm, ind, row, curIndex, data)
  }
}

const isGroupFoundForOldItem = <T>(
  group: T[],
  hierarchyField: string,
  currentForm: T[],
  ind: number
) => group[0] && group[0][hierarchyField] === currentForm[ind][hierarchyField]

const isGroupFoundForNewItem = <T>(group: T[], hierarchyField: string, row: T) =>
  group[0] && group[0][hierarchyField] === row[hierarchyField]

const removeItemFromGroup = <T, R>(
  keyField: string,
  group: T[],
  currentForm: T[],
  ind: number,
  hierarchyField: string,
  closeExpandedRoot?: (root: R | null) => void
) => {
  const oldGroupIndex = group.findIndex((el) => el[keyField] === currentForm[ind][keyField])
  if (oldGroupIndex > -1) {
    if (group.length === 1 && closeExpandedRoot) {
      closeExpandedRoot(group[0][hierarchyField])
    }
    group.splice(oldGroupIndex, 1)
  }
}

const removeAllOldItemsFromEachGroup = <T, R>(
  dataStore: IFormStore<T>,
  keyField: string,
  hierarchyField: string,
  currentForm: T[],
  ind: number,
  closeExpandedRoot?: (root: R | null) => void
) => {
  Object.keys(dataStore.queries).forEach((key2) => {
    // delete old items
    const currentQuery2 = dataStore.queries[key2]
    if (currentQuery2 && currentQuery2.groups) {
      currentQuery2.groups.map((group2) => {
        if (group2[0] && group2[0][hierarchyField] === currentForm[ind][hierarchyField]) {
          const oldGroupIndex = group2.findIndex(
            (el) => el[keyField] === currentForm[ind][keyField]
          )
          if (
            group2.length === 1 &&
            closeExpandedRoot &&
            // This condition was written to stop the root from closing if it has one child
            // @ts-ignore
            group2[0].EntryId === undefined
          ) {
            closeExpandedRoot(group2[0][hierarchyField])
          }
          if (oldGroupIndex > -1) {
            group2.splice(oldGroupIndex, 1)
          }
        }
      })
    }
  })
}

const assignNewItemToEachGroup = <T>(
  dataStore: IFormStore<T>,
  currentForm: T[],
  ind: number,
  row: T,
  curIndex: number,
  data: IFetchResult<T>
) => {
  const newItem2 = Object.assign(currentForm[ind] as any, row)
  data.items.splice(curIndex, 1, newItem2)
  Object.keys(dataStore.queries).forEach((key) => {
    // assign every query new group
    const currentQuery = dataStore.queries[key]
    if (currentQuery.groups) {
      currentQuery.groups.push([newItem2])
    } else {
      currentQuery.groups = [[newItem2]]
    }
  })
}
